<template>
  <button @click="onClick">
    <span>下载交易侠</span>
  </button>
</template>

<script>
import device from '@jin10/utils/lib/device'

export default {
  name: "BtnDownload",
  props: {
    diy: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      window._czc.push(["_trackEvent", "点击", "下载交易侠"]);
      if (device.isMobile) {
        location.href = device.isAndroid ? 'https://cdn.jin10.com/pcclient/apk/traderMasterAndroid.apk' : 'https://apps.apple.com/cn/app/%E4%BA%A4%E6%98%93%E4%BE%A0-%E4%B8%93%E4%B8%9A%E8%A1%8C%E6%83%85%E5%88%86%E6%9E%90%E8%BD%AF%E4%BB%B6/id1221755976'
        return false
      }
      if (this.diy) {
        this.$emit('click')
      } else {
        window.open("https://jiaoyixia.com/", "_blank");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

button {
  position: relative;

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 16px;
    white-space: nowrap;
  }
}

@include mobile {
  button {
    span {
      font-weight: 500 !important;
      font-size: 14px !important;
    }
  }
}
</style>
